import { retry } from '@wix/pricing-plans-utils/http';
import { ControllerParams, PlatformControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { isWixHttpError } from './errors';

export async function retry401<T>(
  wixCodeApi: ControllerParams['controllerConfig']['wixCodeApi'],
  flowAPI: ControllerParams['flowAPI'] | PlatformControllerFlowAPI,
  action: () => Promise<T>,
) {
  return retry(
    {
      times: 1,
      delay: 20,
      refresh: () => wixCodeApi.site.loadNewSession(),
      cancelRetryIf(e) {
        const shouldCancel = !isWixHttpError(e) || e.response?.status !== 401;

        return shouldCancel;
      },
    },
    async () => {
      try {
        const result = await action();
        return result;
      } catch (error: unknown) {
        // mark the error as resolved
        flowAPI.errorHandler.getResolvedError(error);
        throw error;
      }
    },
  );
}
